import Flickity from "flickity";

import 'flickity-imagesloaded';

import $ from 'jquery';
import 'jquery.scrollto';


const initTextMediaTabsBlock = (): void => {

    document.querySelectorAll('.tm-tabs').forEach((block: HTMLElement) => {
        const carousels: Flickity[] = [];

        Array.from(block.querySelectorAll('.tm-tabs__carousel-1'))
            .map((el: HTMLElement) => {
                const f = new Flickity(el, {
                    draggable: false,
                    pageDots: false,
                    prevNextButtons: false,
                    contain: true,
                    cellAlign: 'left',
                    resize: true,
                    wrapAround: true,
                    adaptiveHeight: true,
                    imagesLoaded: false,
                });

                carousels.push(f);
            });

            Array.from(block.querySelectorAll('.tm-tabs__carousel-2'))
            .map((el: HTMLElement) => {
                const f = new Flickity(el, {
                    draggable: false,
                    pageDots: false,
                    prevNextButtons: false,
                    contain: true,
                    cellAlign: 'left',
                    resize: true,
                    wrapAround: true,
                    adaptiveHeight: true,
                    imagesLoaded: false,
                });

                const resize = (): void => {
                    let max = 0;
                    el.querySelectorAll('.tm-tabs__cell').forEach((cell: HTMLElement) => {
                        const content = cell.querySelector('.tm-tabs__cell-content');
                        const height = content.getBoundingClientRect().height;
                        if (height > max) {
                            max = height;
                        }
                    })
        
                    el.style.height = `${max}px`;
                    el.querySelectorAll('.tm-tabs__cell, .flickity-viewport').forEach((e: HTMLElement) => {
                        e.style.height = `${max}px`;
                    });
                }
        
                resize();
                // @ts-ignore
                f.on('resize', () => resize());

                carousels.push(f);
            });

        const container = block.querySelector('.tm-tabs__buttons')
        const btns = Array.from(block.querySelectorAll('.tm-tabs__btn'))
            .map((btn: Element, i) => {
                btn.addEventListener('click', (e: MouseEvent) => {
                    const currentIndex = carousels[0].selectedIndex;
                    const nextIndex = i;

                    if (e.target instanceof Element) {
                        const index = e.target.getAttribute('data-tab-index');
                        carousels.forEach((c: Flickity) => c.select(Number(index)));
                    }

                    btns.forEach((b: Element) => {
                        b.classList.remove('tm-tabs__btn--active');
                    });

                    if (nextIndex === 0) {
                        $(container).scrollTo(btns[nextIndex], {
                            offset: -20,
                            duration: 200,
                        });
                    } else if (nextIndex < currentIndex) {
                        $(container).scrollTo(btns[nextIndex], {
                            offset: -75,
                            duration: 200,
                        });
                    } else if (nextIndex > currentIndex) {
                        $(container).scrollTo(btns[nextIndex], {
                            offset: -75,
                            duration: 200,
                        });
                    }

                    btn.classList.add('tm-tabs__btn--active');
                });

                return btn;
            });
    });
}

export default initTextMediaTabsBlock;